module.exports = __webpack_public_path__ + "img/mew-send-transaction.a5d24bd6.png";